"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var TITULOS = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5',
  6: 'h6'
};
var REGEX_INLINE = /(\*\*[^*]+?\*\*|\*[^*\n]+?\*|`[^`]+`|\[[^\]]+\]\([^)]+\))/g;
var REGEX_TITULO = /^(#{1,6})\s+(.+)$/;
var REGEX_ITEM_LISTA = /^(\s*)([-*+]|\d+\.)\s+(.+)$/;
var REGEX_LINK = /^\[([^\]]+)\]\(([^)]+)\)$/;
var renderizarInline = function renderizarInline(texto, chaveBase) {
  if (!texto) {
    return null;
  }
  var partes = [];
  var ultimo = 0;
  var indice = 0;
  var regex = new RegExp(REGEX_INLINE);
  var match = regex.exec(texto);
  while (match) {
    if (match.index > ultimo) {
      partes.push(texto.slice(ultimo, match.index));
    }
    var token = match[0];
    var chave = "".concat(chaveBase, "-").concat(indice);
    if (token.startsWith('**')) {
      partes.push( /*#__PURE__*/_react["default"].createElement("strong", {
        key: chave
      }, token.slice(2, -2)));
    } else if (token.startsWith('*')) {
      partes.push( /*#__PURE__*/_react["default"].createElement("em", {
        key: chave
      }, token.slice(1, -1)));
    } else if (token.startsWith('`')) {
      partes.push( /*#__PURE__*/_react["default"].createElement("code", {
        key: chave
      }, token.slice(1, -1)));
    } else {
      var link = token.match(REGEX_LINK);
      if (link) {
        partes.push( /*#__PURE__*/_react["default"].createElement("a", {
          key: chave,
          href: link[2],
          target: "_blank",
          rel: "noopener noreferrer"
        }, link[1]));
      } else {
        partes.push(token);
      }
    }
    ultimo = match.index + token.length;
    indice += 1;
    match = regex.exec(texto);
  }
  if (ultimo < texto.length) {
    partes.push(texto.slice(ultimo));
  }
  return partes;
};
var renderizarBlocos = function renderizarBlocos(texto) {
  var linhas = String(texto).replace(/\r\n/g, '\n').split('\n');
  var elementos = [];
  var indice = 0;
  var chave = 0;
  while (indice < linhas.length) {
    var linha = linhas[indice];
    if (linha.trim().startsWith('```')) {
      var trecho = [];
      indice += 1;
      while (indice < linhas.length && !linhas[indice].trim().startsWith('```')) {
        trecho.push(linhas[indice]);
        indice += 1;
      }
      if (indice < linhas.length) {
        indice += 1;
      }
      elementos.push( /*#__PURE__*/_react["default"].createElement("pre", {
        key: "pre-".concat(chave)
      }, /*#__PURE__*/_react["default"].createElement("code", null, trecho.join('\n'))));
      chave += 1;
      continue;
    }
    var titulo = linha.match(REGEX_TITULO);
    if (titulo) {
      var nivel = titulo[1].length;
      var TagTitulo = TITULOS[nivel];
      if (TagTitulo) {
        elementos.push( /*#__PURE__*/_react["default"].createElement(TagTitulo, {
          key: "h-".concat(chave)
        }, renderizarInline(titulo[2], "h-".concat(chave))));
        chave += 1;
      }
      indice += 1;
      continue;
    }
    var itemLista = linha.match(REGEX_ITEM_LISTA);
    if (itemLista) {
      var ordenada = /^\d+\./.test(itemLista[2]);
      var itens = [];
      while (indice < linhas.length) {
        var item = linhas[indice].match(REGEX_ITEM_LISTA);
        if (!item) {
          break;
        }
        itens.push( /*#__PURE__*/_react["default"].createElement("li", {
          key: "li-".concat(chave, "-").concat(itens.length)
        }, renderizarInline(item[3], "li-".concat(chave, "-").concat(itens.length))));
        indice += 1;
      }
      var TagLista = ordenada ? 'ol' : 'ul';
      elementos.push( /*#__PURE__*/_react["default"].createElement(TagLista, {
        key: "l-".concat(chave)
      }, itens));
      chave += 1;
      continue;
    }
    if (!linha.trim()) {
      indice += 1;
      continue;
    }
    var paragrafo = [linha];
    indice += 1;
    while (indice < linhas.length && linhas[indice].trim() && !linhas[indice].match(REGEX_TITULO) && !linhas[indice].match(REGEX_ITEM_LISTA) && !linhas[indice].trim().startsWith('```')) {
      paragrafo.push(linhas[indice]);
      indice += 1;
    }
    elementos.push( /*#__PURE__*/_react["default"].createElement("p", {
      key: "p-".concat(chave)
    }, renderizarInline(paragrafo.join(' '), "p-".concat(chave))));
    chave += 1;
  }
  return elementos;
};
var LimiteErroMarkdown = /*#__PURE__*/function (_Component) {
  _inherits(LimiteErroMarkdown, _Component);
  var _super = _createSuper(LimiteErroMarkdown);
  function LimiteErroMarkdown(props) {
    var _this;
    _classCallCheck(this, LimiteErroMarkdown);
    _this = _super.call(this, props);
    _this.state = {
      falhou: false
    };
    return _this;
  }
  _createClass(LimiteErroMarkdown, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.falhou && prevProps.texto !== this.props.texto) {
        this.setState({
          falhou: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.falhou) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            whiteSpace: 'pre-wrap'
          }
        }, this.props.texto);
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        falhou: true
      };
    }
  }]);
  return LimiteErroMarkdown;
}(_react.Component);
var ConteudoAssistente = function ConteudoAssistente(_ref) {
  var texto = _ref.texto;
  if (!texto) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(LimiteErroMarkdown, {
    texto: texto
  }, renderizarBlocos(texto));
};
var _default = ConteudoAssistente;
exports["default"] = _default;